import {
    FETCH_DEMOGRAPHIC_COMPARE,
    FETCH_DEMOGRAPHIC_COMPARE_FETCHING,
    FETCH_DEMOGRAPHIC_COMPARE_SUCCESS,
    FETCH_DEMOGRAPHIC_COMPARE_FAIL
} from 'actions/ActionTypes.js';

const INITIAL_STATE = {
    data: {},
    demographicCompareFetching: {},
    demographicCompareFetchFail: {}
};

// ======= Fetching Handlers =======
const fetchDemographicCompareFetching = (state, action) => {
    return {
        data: {
            ...state.data,
            [action.activityType]: {}
        },
        demographicCompareFetching: {
            ...state.demographicCompareFetching,
            [action.activityType]: true
        },
        demographicCompareFetchFail: {
            ...state.demographicCompareFetchFail,
            [action.activityType]: false
        }
    };
};

const fetchDemographicCompareSuccess = (state, action) => {
    return {
        data: {
            ...state.data,
            [action.activityType]: action.data
        },
        demographicCompareFetching: {
            ...state.demographicCompareFetching,
            [action.activityType]: false
        },
        demographicCompareFetchFail: {
            ...state.demographicCompareFetchFail,
            [action.activityType]: false
        }
    };
};

const fetchDemographicCompareFail = (state, action) => {
    return {
        data: {
            ...state.data,
            [action.activityType]: null
        },
        demographicCompareFetching: {
            ...state.demographicCompareFetching,
            [action.activityType]: false
        },
        demographicCompareFetchFail: {
            ...state.demographicCompareFetchFail,
            [action.activityType]: true
        }
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_DEMOGRAPHIC_COMPARE_FETCHING]: fetchDemographicCompareFetching,
    [FETCH_DEMOGRAPHIC_COMPARE_SUCCESS]: fetchDemographicCompareSuccess,
    [FETCH_DEMOGRAPHIC_COMPARE_FAIL]: fetchDemographicCompareFail
};

// ======= Default Action =======
export default function demographicCompare(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function fetchDemographicCompare(
    gender,
    age,
    activityType,
    field,
    lang,
    measurementSystem,
    year,
    month,
    evictCache
) {
    return {
        type: FETCH_DEMOGRAPHIC_COMPARE,
        gender,
        age,
        activityType,
        field,
        lang,
        measurementSystem,
        year,
        month,
        meta: {
            cacheTime: evictCache ? null : 2000
        }
    };
}

// ======= Selectors =======
export const getDemographicCompare = (state, activityType) => {
    return state.demographicCompare.data[activityType] ? state.demographicCompare.data[activityType] : null;
};

export const isDemographicCompareFetching = (state, activityType) => {
    return state.demographicCompare.demographicCompareFetching &&
        state.demographicCompare.demographicCompareFetching[activityType]
        ? state.demographicCompare.demographicCompareFetching[activityType]
        : null;
};

export const didDemographicCompareFetchFail = (state, activityType) => {
    return state.demographicCompare.demographicCompareFetchFail &&
        state.demographicCompare.demographicCompareFetchFail[activityType]
        ? state.demographicCompare.demographicCompareFetchFail[activityType]
        : null;
};
